<template>
    <div class="payroll-assessments">
        <div v-for="source in sources" :key="source.key" class="assessment-source">
            <span class="assessment-ktu"><PayrollKtuValues v-if="source.ktu !== null" :values="[source.ktu]" /><span v-else class="assessment-missing" title="КТУ не указан">—</span></span>
            <div class="assessment-content">
                <span v-if="source.part.note_sources && source.part.note_sources.length" class="assessment-origin"><a v-for="link in source.part.note_sources" :key="link.url" :href="link.url" target="_blank" rel="noopener noreferrer" class="mr-2">{{ link.label }} ↗</a></span>
                <a v-else-if="source.part.source_url" :href="source.part.source_url" target="_blank" rel="noopener noreferrer" class="assessment-origin" :title="sourceLabel(source.part)">{{ sourceLabel(source.part) || 'Источник' }} ↗</a>
                <span v-else-if="sourceLabel(source.part)" class="assessment-origin" :title="sourceLabel(source.part)">{{ sourceLabel(source.part) }}</span>
                <div v-for="field in source.fields" :key="field.key" class="assessment-field">
                    <span v-if="source.fields.length > 1" class="assessment-field-label">{{ field.label || 'Характеристика' }}</span>
                    <div class="assessment-text-wrap" :class="{'is-expanded': isExpanded(source, field)}">
                        <button type="button" class="assessment-open" :style="isExpanded(source, field) ? null : {maxHeight: `${textHeight}px`}" :data-field="fieldKey(source, field)" aria-haspopup="dialog" aria-label="Открыть подробную характеристику" @click="$emit('open', detailSource(source))">
                            <q v-if="typeof field.value === 'string' && !field.system" class="assessment-text user-quote">{{ characteristicText(field.value) }}</q>
                            <span v-else class="assessment-text">{{ characteristicText(field.value) }}</span>
                        </button>
                        <button v-if="isExpanded(source, field) || clipped[fieldKey(source, field)]" type="button" class="assessment-more" :aria-expanded="String(isExpanded(source, field))" @click.stop="toggle(source, field)">{{ isExpanded(source, field) ? 'Свернуть' : 'Ещё' }}</button>
                    </div>
                    <span v-if="!field.system" class="assessment-meta"><AssignmentAuthor label="Автор" :name="field.author && field.author.name" :user-id="field.author && field.author.user_id" fallback="не сохранён" /></span>
                </div>
                <button v-if="!source.fields.length" type="button" class="assessment-open assessment-empty" :class="{'assessment-required': source.missingRequired}" aria-haspopup="dialog" @click="$emit('open', detailSource(source))">{{ source.emptyLabel }}</button>
            </div>
        </div>
        <details v-if="details.length" class="assessment-details" @toggle="scheduleMeasure">
            <summary>Архивные сведения</summary>
            <article v-for="item in details" :key="item.id">
                <small>{{ item.object_name || 'Сведения месяца' }} · {{ item.source_label || 'Архив' }}</small>
                <div v-for="fact in item.facts" :key="fact.key">{{ fact.label }}: {{ characteristicText(fact.value) }}</div>
                <small v-for="(field, index) in item.note_authors || []" :key="index"><AssignmentAuthor label="Автор" :name="field.author && field.author.name" :user-id="field.author && field.author.user_id" fallback="не сохранён" /></small>
                <a v-if="item.source_url" :href="item.source_url" target="_blank" rel="noopener noreferrer">Источник ↗</a>
            </article>
        </details>
    </div>
</template>
<script>
import characteristics from './payrollCharacteristics';
import PayrollKtuValues from './PayrollKtuValues.vue';
import AssignmentAuthor from '@/components/AssignmentAuthor.vue';
export default {
    name: 'PayrollAssessmentSources', components: {PayrollKtuValues, AssignmentAuthor},
    props: {parts: {type: Array, default: () => []}, entries: {type: Array, default: null}, supplements: {type: Array, default: () => []}, hideObject: Boolean},
    data: () => ({expandedFields: {}, clipped: {}, textHeight: 30}),
    computed: {
        sources() {
            const entries = this.entries || characteristics.assessments(this.parts);
            const notes = (this.supplements || []).flatMap(item => (item.facts || []).filter(fact => fact.key === 'notes').map(fact => ({
                key: `extra:${item.id}:${fact.key}`, part: item, ktu: null,
                fields: [{key: fact.key, value: fact.value, author: (item.note_authors || [])[0] && item.note_authors[0].author}]
            })));
            return entries.concat(notes);
        },
        details() { return (this.supplements || []).map(item => ({...item, facts: (item.facts || []).filter(fact => fact.key !== 'notes')})).filter(item => item.facts.length); }
    },
    watch: {sources() { this.$nextTick(this.scheduleMeasure); }},
    mounted() {
        if (typeof ResizeObserver !== 'undefined') {
            this.observer = new ResizeObserver(this.scheduleMeasure);
            this.observer.observe(this.$el.closest('tr') || this.$el);
            this.observer.observe(this.$el);
        }
        window.addEventListener('resize', this.scheduleMeasure);
        this.$nextTick(this.scheduleMeasure);
    },
    beforeDestroy() {
        if (this.observer) this.observer.disconnect();
        window.removeEventListener('resize', this.scheduleMeasure);
        cancelAnimationFrame(this.measureFrame);
    },
    methods: {
        characteristicText: characteristics.text, authorLabel: characteristics.authorLabel,
        sourceLabel(part) {
            if (part && part.source_label) return [this.hideObject && !part.unassigned ? '' : part.object_name, part.source_label].filter(Boolean).join(' · ');
            return this.hideObject ? '' : part && part.object_name || '';
        },
        fieldKey(source, field) { return `${source.key}:${field.key}`; },
        isExpanded(source, field) { return !!this.expandedFields[this.fieldKey(source, field)]; },
        detailSource(source) {
            if (source.part.source_details) return source.part;
            return {...source.part, ktu: source.ktu, source_details: {characteristics: source.fields, ktu_evidence: []}};
        },
        scheduleMeasure() {
            if (!this.measureFrame) this.measureFrame = requestAnimationFrame(() => { this.measureFrame = null; this.measure(); });
        },
        measure() {
            const root = this.$el, cell = root.closest('td'), row = cell && cell.parentElement;
            const texts = Array.from(root.querySelectorAll('[data-field]'));
            if (!texts.length) return;
            const mobile = window.innerWidth <= 900;
            let available = 0;
            if (row && !mobile) {
                // Read actual contents of OTHER cells: their equalised td height includes our own text.
                Array.from(row.children).filter(other => other !== cell).forEach(other => {
                    const range = document.createRange(); range.selectNodeContents(other);
                    const rect = range.getBoundingClientRect(), style = getComputedStyle(other);
                    if (rect.height) available = Math.max(available, rect.bottom - other.getBoundingClientRect().top + parseFloat(style.paddingBottom));
                });
                const style = getComputedStyle(cell);
                available -= parseFloat(style.paddingTop) + parseFloat(style.paddingBottom) + 1;
            }
            const textTotal = texts.reduce((sum, text) => sum + text.getBoundingClientRect().height, 0);
            const metadata = root.getBoundingClientRect().height - textTotal;
            const textStyle = getComputedStyle(texts[0].firstElementChild);
            const lineHeight = parseFloat(textStyle.lineHeight) || 18;
            const padding = (parseFloat(textStyle.paddingTop) || 0) + (parseFloat(textStyle.paddingBottom) || 0);
            const budget = mobile ? lineHeight * 3 + padding : (available - metadata) / texts.length;
            const height = Math.max(lineHeight + padding, Math.floor((budget - padding) / lineHeight) * lineHeight + padding);
            if (this.textHeight !== height) { this.textHeight = height; this.$nextTick(this.scheduleMeasure); return; }
            const clipped = {};
            texts.forEach(text => { clipped[text.dataset.field] = text.scrollHeight > text.clientHeight + 1; });
            if (JSON.stringify(this.clipped) !== JSON.stringify(clipped)) this.clipped = clipped;
        },
        async toggle(source, field) {
            const row = this.$el.closest('tr'), ancestors = [];
            let node = this.$el.parentElement;
            while (node) { if (node.scrollHeight > node.clientHeight) ancestors.push({node, top: node.scrollTop}); node = node.parentElement; }
            const top = row && row.getBoundingClientRect().top;
            const key = this.fieldKey(source, field);
            this.$set(this.expandedFields, key, !this.expandedFields[key]);
            await this.$nextTick();
            ancestors.forEach(saved => { saved.node.scrollTop = saved.top; });
            const scroller = ancestors.find(saved => /auto|scroll/.test(getComputedStyle(saved.node).overflowY)) || ancestors[ancestors.length - 1];
            if (row && scroller) scroller.node.scrollTop += row.getBoundingClientRect().top - top;
            this.scheduleMeasure();
        }
    }
};
</script>
<style scoped>
.payroll-assessments { min-width: 0; font-size: inherit; line-height: 1.3; }
.assessment-source { display: grid; grid-template-columns: 30px minmax(0, 1fr); align-items: start; gap: 5px; color: #334155; }
.assessment-content { min-width: 0; }
.assessment-text-wrap { position: relative; }
.assessment-open { display: block; width: 100%; padding: 0; border: 0; border-radius: 0; background: transparent; color: inherit; font: inherit; line-height: inherit; text-align: left; overflow: hidden; }
.assessment-text { display: block; min-height: 0; margin: 0; overflow-wrap: anywhere; white-space: pre-wrap; }
.assessment-open { cursor: pointer; }
.assessment-open:hover .assessment-text, .assessment-open:focus-visible .assessment-text { color: #1769aa; background-color: #e8f2fc; text-decoration: underline; text-underline-offset: 2px; }
.assessment-meta, .assessment-field-label, .assessment-origin { display: block; margin-top: 1px; color: #687583; font-size: 11px; line-height: 1.15; }
.assessment-origin { margin: 0 0 2px; color: #43566c; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.assessment-meta ::v-deep .assignment-author { display: flex !important; align-items: baseline; gap: 3px; min-width: 0; white-space: nowrap; }
.assessment-meta ::v-deep .employee-link { min-width: 0; max-width: 100%; }
.assessment-meta ::v-deep .employee-link-wrap { min-width: 0; }
.assessment-meta ::v-deep .employee-link__name { display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.assessment-ktu { padding-top: 1px; text-align: center; }
.assessment-empty, .assessment-missing { color: #687583; }
.assessment-required { color: #a33829; font-weight: 600; }
.assessment-more { position: absolute; bottom: 0; right: 0; padding: 1px 4px; border: 0; border-radius: 2px; color: #1769aa; background: #edf5fd; box-shadow: -5px 0 5px #edf5fd; font: inherit; font-size: 12px; line-height: 18px; }
.is-expanded .assessment-more { position: static; float: right; margin-top: -20px; }
.is-expanded .assessment-text { padding-bottom: 20px; }
.assessment-open:focus-visible, .assessment-more:focus-visible { outline: 2px solid #2875b9; outline-offset: 1px; }
.assessment-source + .assessment-source, .assessment-details { margin-top: 4px; padding-top: 4px; border-top: 1px solid #d5dee7; }
.assessment-field + .assessment-field, .assessment-details article + article { margin-top: 6px; }
.assessment-details small, .assessment-source-link { display: block; color: #687583; font-size: 11px; }
@media (max-width: 900px) {
    .assessment-meta { font-size: 12px; }
    .assessment-more { line-height: 22px; }
}
</style>
